var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailedToast(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58567",
    "data-name": "Group 58567",
    transform: "translate(20284 15590)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7791",
    "data-name": "Rectangle 7791",
    width: 50,
    height: 50,
    rx: 12,
    transform: "translate(-20284 -15590)",
    fill: "#ff3926"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-close-circle",
    "data-name": "Icon ionic-md-close-circle",
    d: "M14.941,3.375A11.566,11.566,0,1,0,26.508,14.941,11.526,11.526,0,0,0,14.941,3.375Zm5.783,15.73-1.619,1.619-4.164-4.164-4.164,4.164L9.158,19.105l4.164-4.164L9.158,10.777l1.619-1.619,4.164,4.164,4.164-4.164,1.619,1.619-4.164,4.164Z",
    transform: "translate(-20274.375 -15580.375)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedToast);
export default __webpack_public_path__ + "static/media/failed_toast.903997e87fe0706f58a9f617d1a01c4b.svg";
export { ForwardRef as ReactComponent };